import configValues from './config/main.env.js';

// Export individual values from the config
export const API_BASE_URL = configValues.API_BASE_URL;
export const API_BASE_URL_NEW = configValues.API_BASE_URL_NEW;
export const CUSTOMER_FORM_URL = configValues.CUSTOMER_FORM_URL;
export const optimo_whatsapp_number = configValues.optimo_whatsapp_number;
export const WEBSOCKET_URL = configValues.WEBSOCKET_URL;
export const DIGIO_ENVIRONMENT = configValues.DIGIO_ENVIRONMENT;